var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"EmittingAnalogClock lxn-margin-auto lxn-overflow-hidden lxn-border-round lxn-pos-rel",style:({width: (_vm.size + 10) + 'px', height: (_vm.size + 10) + 'px'}),attrs:{"id":_vm.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }